import type { ComponentSchema, FieldSchema } from '../../../../../schema-types'
import { SUPPORTED_PAGES } from '../../_builder-constants'

const MENU_ITEM_SCHEMA: FieldSchema[] = [
  { key: 'label', label: 'Label', type: 'string' },
  { key: 'href', label: 'Link URL', type: 'string' },
  {
    key: 'type',
    label: 'Type',
    type: 'select',
    options: [
      { label: 'Link', value: 'link' },
      { label: 'Shop panel (category cards)', value: 'categories' },
    ],
    default: 'link',
  },
  { key: 'badge', label: 'Badge', type: 'string', placeholder: 'New', help: 'Small label next to the item.' },
]

/** Fresh Basket header: rotating announcement, wide search, labelled icons and a category bar. */
export const schema: ComponentSchema = {
  type: 'header',
  label: 'Header',
  description: 'Announcement bar, logo, search, shopper icons and the main menu.',
  supportedPages: [...SUPPORTED_PAGES],
  variants: [{ id: 'v1', label: 'Two-tier' }],
  commonFields: [
    { key: 'logo.src', label: 'Logo', type: 'image' },
    { key: 'logo.alt', label: 'Logo alt text', type: 'string' },
    {
      key: 'topbar',
      label: 'Announcement bar',
      type: 'object',
      fields: [
        { key: 'active', label: 'Show announcement bar', type: 'boolean', default: true },
        {
          key: 'messages',
          label: 'Messages',
          type: 'array',
          help: 'More than one message rotates every few seconds.',
          itemSchema: [
            { key: 'text', label: 'Text', type: 'localized-string' },
            { key: 'link', label: 'Link', type: 'string' },
          ],
        },
        { key: 'dismissible', label: 'Shoppers can close it', type: 'boolean', default: false },
      ],
    },
    { key: 'searchPlaceholder', label: 'Search placeholder', type: 'string', placeholder: 'Search products…' },
    {
      key: 'actions',
      label: 'Icons',
      type: 'object',
      fields: [
        { key: 'showSearch', label: 'Search', type: 'boolean', default: true },
        { key: 'showAccount', label: 'Account', type: 'boolean', default: true },
        { key: 'showWishlist', label: 'Wishlist', type: 'boolean', default: true },
        { key: 'showCart', label: 'Cart', type: 'boolean', default: true },
        {
          key: 'cartAction',
          label: 'Cart opens',
          type: 'select',
          options: [
            { label: 'Cart drawer', value: 'sidebar' },
            { label: 'Cart page', value: 'page' },
          ],
          default: 'sidebar',
        },
      ],
    },
    { key: 'menu', label: 'Main menu', type: 'array', itemSchema: MENU_ITEM_SCHEMA },
  ],
}
